/* ============================================================
   ONI(tm) Mask landing page - runtime
   - variant selection synced across every buy box on the page
   - real add to cart through the Shopify Ajax API
   - sticky mobile ATC bar, FAQ, reveal-on-scroll, hero video
   No fake timers, no fake stock: every number rendered here comes
   from the Shopify product object at render time.
   ============================================================ */
(function () {
  'use strict';

  if (window.OniLP) return; // script may be injected by several sections

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var OniLP = {
    product: null,
    variant: null,
    quantity: 1,
    selected: [],
    config: { postAdd: 'drawer', postAddMobile: 'drawer', pushDataLayer: false },
    subscribers: [],

    setProduct: function (data) {
      if (this.product || !data) return;
      this.product = data;
      this.selected = (data.current || (data.variants[0] && data.variants[0].options) || []).slice();
      this.variant = this.findVariant(this.selected) || data.variants[0];

      // deep link: /pages/oni-mask-lp?variant=123 (used by ad URLs)
      try {
        var requested = new URL(window.location.href).searchParams.get('variant');
        if (requested) {
          for (var i = 0; i < data.variants.length; i++) {
            if (String(data.variants[i].id) === String(requested)) {
              this.variant = data.variants[i];
              this.selected = this.variant.options.slice();
              break;
            }
          }
        }
      } catch (e) {
        /* no URL API: keep the default selection */
      }
    },

    subscribe: function (fn) {
      this.subscribers.push(fn);
      if (this.variant) fn(this.variant, this);
    },

    publish: function () {
      for (var i = 0; i < this.subscribers.length; i++) {
        try {
          this.subscribers[i](this.variant, this);
        } catch (e) {
          /* one broken listener must never break the buy flow */
        }
      }
      document.dispatchEvent(
        new CustomEvent('oni:variant:change', { detail: { variant: this.variant } })
      );
    },

    findVariant: function (options) {
      if (!this.product) return null;
      var key = options.join('||');
      var list = this.product.variants;
      for (var i = 0; i < list.length; i++) {
        if (list[i].options.join('||') === key) return list[i];
      }
      return null;
    },

    /* Every variant that matches `value` at `index`. Used to work out
       whether an option value is buyable at all. */
    isValueAvailable: function (index, value) {
      if (!this.product) return true;
      var list = this.product.variants;
      for (var i = 0; i < list.length; i++) {
        if (list[i].options[index] === value && list[i].available) return true;
      }
      return false;
    },

    isComboAvailable: function (index, value) {
      var probe = this.selected.slice();
      probe[index] = value;
      var v = this.findVariant(probe);
      return !!(v && v.available);
    },

    select: function (index, value) {
      if (!this.product) return;
      var probe = this.selected.slice();
      probe[index] = value;
      var variant = this.findVariant(probe);

      /* Combination does not exist at all (not the same thing as sold out):
         fall back to the first existing combination for the value the
         shopper just clicked so the UI never lands on nothing. */
      if (!variant) {
        var list = this.product.variants;
        for (var i = 0; i < list.length; i++) {
          if (list[i].options[index] === value) {
            variant = list[i];
            break;
          }
        }
      }
      if (!variant) return;

      this.selected = variant.options.slice();
      this.variant = variant;
      this.publish();
      this.updateUrl();
    },

    setQuantity: function (qty) {
      this.quantity = Math.max(1, parseInt(qty, 10) || 1);
      this.publish();
    },

    updateUrl: function () {
      if (!this.variant || !window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {
        /* older browsers: skip, nothing depends on it */
      }
    },

    cartAdd: function (variantId, quantity) {
      var addUrl =
        ((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js';
      var body = {
        items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }]
      };
      var wantsDrawer = window.matchMedia('(min-width: 990px)').matches
        ? OniLP.config.postAdd === 'drawer'
        : OniLP.config.postAddMobile === 'drawer';
      if (wantsDrawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status === 422 || json.status === 'bad_request') {
            var err = new Error(json.description || json.message || 'Add to cart failed');
            err.data = json;
            throw err;
          }
          return json;
        });
      });
    },

    afterAdd: function (payload) {
      if (OniLP.config.pushDataLayer && window.dataLayer && OniLP.variant) {
        window.dataLayer.push({
          event: 'oni_add_to_cart',
          currency: OniLP.product && OniLP.product.currency,
          value: (OniLP.variant.price / 100) * OniLP.quantity,
          items: [
            {
              item_id: String(OniLP.variant.id),
              item_name: OniLP.product && OniLP.product.title,
              item_variant: OniLP.variant.title,
              price: OniLP.variant.price / 100,
              quantity: OniLP.quantity
            }
          ]
        });
      }

      /* 990px is the same line the sticky bar uses, so "mobile" here means
         exactly the layout the shopper is looking at. Read at click time, not
         at load, so a rotated phone or a resized window still gets it right. */
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var mode = isDesktop ? OniLP.config.postAdd : OniLP.config.postAddMobile;

      if (mode === 'cart') {
        window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        return;
      }

      if (mode === 'drawer' && OniLP.openDrawer(payload)) return;

      // default (and fallback): straight to checkout - fewest steps for cold traffic
      window.location.href = root + 'checkout';
    },

    /* Refresh + open the theme cart drawer using the sections returned by
       /cart/add.js. Returns false when the theme has no drawer so the
       caller can fall back to checkout. */
    openDrawer: function (payload) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return false;

      try {
        if (payload && payload.sections) {
          var parser = new DOMParser();

          if (payload.sections['cart-drawer']) {
            var doc = parser.parseFromString(payload.sections['cart-drawer'], 'text/html');
            var fresh = doc.querySelector('#CartDrawer');
            var current = drawer.querySelector('#CartDrawer');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
          }

          if (payload.sections['cart-icon-bubble']) {
            var bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) bubble.innerHTML = payload.sections['cart-icon-bubble'];
          }
        }

        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
        }
        return true;
      } catch (e) {
        return false;
      }
    },

    scrollTo: function (selector) {
      var target = document.querySelector(selector);
      if (!target) return;
      var header = document.querySelector('.section-header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  window.OniLP = OniLP;

  /* ---------------------------------------------------------- helpers */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function setText(nodes, value) {
    nodes.forEach(function (n) {
      n.textContent = value;
    });
  }

  function toggle(node, show) {
    if (!node) return;
    node.hidden = !show;
  }

  /* Repaint every price / availability / image node on the page. */
  function renderGlobals(variant) {
    if (!variant) return;

    setText($$('[data-oni-price]'), variant.price_formatted);
    setText($$('[data-oni-variant-title]'), variant.title);

    $$('[data-oni-compare-wrap]').forEach(function (wrap) {
      var has = !!variant.compare_at_price_formatted;
      toggle(wrap, has);
      if (has) setText($$('[data-oni-compare]', wrap), variant.compare_at_price_formatted);
    });

    $$('[data-oni-save]').forEach(function (node) {
      var has = variant.save_percent > 0;
      toggle(node, has);
      if (has) {
        node.textContent = (node.getAttribute('data-oni-save-label') || 'Save [percent]%').replace(
          '[percent]',
          variant.save_percent
        );
      }
    });

    $$('[data-oni-variant-id]').forEach(function (input) {
      input.value = variant.id;
    });

    $$('[data-oni-image]').forEach(function (img) {
      if (!variant.image || img.getAttribute('src') === variant.image) return;
      img.setAttribute('src', variant.image);
      if (variant.image_srcset) img.setAttribute('srcset', variant.image_srcset);
      img.setAttribute('alt', variant.image_alt || '');
    });

    $$('[data-oni-thumb]').forEach(function (img) {
      if (!variant.image_thumb || img.getAttribute('src') === variant.image_thumb) return;
      img.setAttribute('src', variant.image_thumb);
    });

    $$('[data-oni-stock]').forEach(function (node) {
      var text = variant.available ? node.getAttribute('data-in-stock') : node.getAttribute('data-out-of-stock');
      if (variant.available && variant.inventory_message) text = variant.inventory_message;
      node.classList.toggle('is-out', !variant.available);
      var label = $('[data-oni-stock-label]', node);
      if (label && text) label.textContent = text;
      toggle(node, !!text);
    });
  }

  /* ------------------------------------------------------ <oni-buy-box> */

  function initBuyBox(el) {
    if (el.dataset.oniReady === 'true') return;
    el.dataset.oniReady = 'true';

    var dataNode = $('[data-oni-product-json]', el);
    if (dataNode) {
      try {
        var parsed = JSON.parse(dataNode.textContent);
        OniLP.setProduct(parsed);
        /* The first buy box on the page owns the post-add behaviour, so a
           second one (final CTA) can never contradict it. */
        if (parsed.config && !OniLP.configLocked) {
          OniLP.configLocked = true;
          if (parsed.config.postAdd) OniLP.config.postAdd = parsed.config.postAdd;
          if (parsed.config.postAddMobile) {
            OniLP.config.postAddMobile = parsed.config.postAddMobile;
          }
          if (typeof parsed.config.pushDataLayer === 'boolean') {
            OniLP.config.pushDataLayer = parsed.config.pushDataLayer;
          }
        }
      } catch (e) {
        return;
      }
    }
    if (!OniLP.product) return;

    var form = $('form[data-oni-form]', el);
    var button = $('[data-oni-atc]', el);
    var notify = $('[data-oni-notify]', el);
    var errorBox = $('[data-oni-error]', el);
    var qtyInput = $('[data-oni-qty-input]', el);

    /* option buttons ---------------------------------------------------- */
    $$('[data-oni-option-value]', el).forEach(function (btn) {
      btn.addEventListener('click', function () {
        OniLP.select(parseInt(btn.getAttribute('data-oni-option-index'), 10), btn.getAttribute('data-oni-option-value'));
      });
    });

    /* quantity ---------------------------------------------------------- */
    if (qtyInput) {
      $$('[data-oni-qty-step]', el).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-oni-qty-step'), 10);
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
          OniLP.setQuantity(qtyInput.value);
        });
      });
      qtyInput.addEventListener('change', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        OniLP.setQuantity(qtyInput.value);
      });
    }

    /* add to cart -------------------------------------------------------- */
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!OniLP.variant || !OniLP.variant.available) return;
        submitAdd(button, qtyInput ? qtyInput.value : 1, errorBox);
      });
    }

    /* keep this box in sync --------------------------------------------- */
    OniLP.subscribe(function (variant) {
      renderGlobals(variant);

      $$('[data-oni-option-value]', el).forEach(function (btn) {
        var index = parseInt(btn.getAttribute('data-oni-option-index'), 10);
        var value = btn.getAttribute('data-oni-option-value');
        var isSelected = OniLP.selected[index] === value;
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');

        /* a colour is crossed out only when no variant of that colour is
           buyable; a style pill shows sold out for the current colour */
        var unavailable = btn.getAttribute('data-oni-option-scope') === 'combo'
          ? !OniLP.isComboAvailable(index, value)
          : !OniLP.isValueAvailable(index, value);
        btn.classList.toggle('is-unavailable', unavailable);

        var meta = $('[data-oni-option-meta]', btn);
        if (meta) {
          var probe = OniLP.selected.slice();
          probe[index] = value;
          var combo = OniLP.findVariant(probe);
          meta.textContent = unavailable
            ? meta.getAttribute('data-sold-out-label') || 'Sold out'
            : (combo && combo.price_formatted) || '';
        }
      });

      $$('[data-oni-selected-value]', el).forEach(function (node) {
        var index = parseInt(node.getAttribute('data-oni-selected-value'), 10);
        node.textContent = OniLP.selected[index] || '';
      });

      if (button) {
        var label = $('[data-oni-atc-label]', button);
        button.disabled = !variant.available;
        button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        if (label) {
          label.textContent = variant.available
            ? button.getAttribute('data-label-available') || 'Add to cart'
            : button.getAttribute('data-label-sold-out') || 'Sold out';
        }
        toggle(button, variant.available || !notify);
      }

      if (notify) {
        toggle(notify, !variant.available);
        $$('[data-oni-notify-variant]', notify).forEach(function (input) {
          input.value = OniLP.product.title + ' - ' + variant.title + ' (#' + variant.id + ')';
        });
      }

      if (errorBox) errorBox.classList.remove('is-visible');
    });
  }

  function submitAdd(button, qty, errorBox) {
    if (!button) return;
    button.classList.add('is-loading');
    if (errorBox) errorBox.classList.remove('is-visible');

    OniLP.cartAdd(OniLP.variant.id, qty)
      .then(function (payload) {
        /* Clear the spinner before handing off. Only the checkout and cart
           options navigate away; the drawer stays on the page, and leaving the
           button spinning there made it look permanently stuck. */
        button.classList.remove('is-loading');
        OniLP.afterAdd(payload);
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        if (errorBox) {
          errorBox.textContent = err.message || 'Something went wrong. Please try again.';
          errorBox.classList.add('is-visible');
        }
      });
  }

  /* --------------------------------------------------- sticky ATC bar */

  function initSticky(el) {
    if (el.dataset.oniReady === 'true') return;
    el.dataset.oniReady = 'true';

    var button = $('[data-oni-sticky-atc]', el);
    var heroSentinel = $('[data-oni-sticky-start]');
    var mainAtc = $('[data-oni-primary-atc]');
    var pastHero = false;
    var atcInView = false;

    function update() {
      el.classList.toggle('is-visible', pastHero && !atcInView);
    }

    if ('IntersectionObserver' in window && heroSentinel) {
      new IntersectionObserver(
        function (entries) {
          pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          update();
        },
        { threshold: 0 }
      ).observe(heroSentinel);
    } else {
      pastHero = true;
      update();
    }

    if ('IntersectionObserver' in window && mainAtc) {
      new IntersectionObserver(
        function (entries) {
          atcInView = entries[0].isIntersecting;
          update();
        },
        { threshold: 0.2 }
      ).observe(mainAtc);
    }

    if (button) {
      button.addEventListener('click', function () {
        if (!OniLP.variant) return;
        if (!OniLP.variant.available) {
          OniLP.scrollTo('[data-oni-buybox]');
          return;
        }
        submitAdd(button, OniLP.quantity, null);
      });
    }

    OniLP.subscribe(function (variant) {
      if (!button) return;
      var label = $('[data-oni-atc-label]', button);
      if (label) {
        label.textContent = variant.available
          ? button.getAttribute('data-label-available') || 'Add to cart'
          : button.getAttribute('data-label-sold-out') || 'Notify me';
      }
      button.classList.toggle('oni-btn--ghost', !variant.available);
    });
  }

  /* ------------------------------------------------------------- video */

  /* The hero video costs nothing until someone asks for it.

     There is no autoplay, no scroll-triggered mounting and no preloading: the
     poster is a plain responsive <img>, the <video> ships preload="none" with
     no sources fetched, and the only thing that ever starts a network request
     is the play button. On a slow connection the hero is just a photo, which is
     the point.

     Because the click is a real user gesture, playback can start with sound and
     the browser's own controls, so there is no separate unmute button. */
  function initVideo(el) {
    if (el.dataset.oniReady === 'true') return;
    el.dataset.oniReady = 'true';

    var type = el.getAttribute('data-video-type'); // youtube | vimeo | native
    var id = el.getAttribute('data-video-id');
    var title = el.getAttribute('data-video-title') || 'Product video';
    var playBtn = $('[data-oni-play]', el);
    var nativeVideo = $('video', el);
    var mounted = false;

    function embedSrc() {
      if (type === 'vimeo') {
        return (
          'https://player.vimeo.com/video/' + id +
          '?autoplay=1&muted=0&loop=1&playsinline=1&byline=0&title=0'
        );
      }
      return (
        'https://www.youtube.com/embed/' + id +
        '?autoplay=1&mute=0&playsinline=1&rel=0&modestbranding=1&loop=1' +
        '&enablejsapi=1&playlist=' + id
      );
    }

    function play() {
      if (mounted) return;
      mounted = true;

      if (type === 'native') {
        if (!nativeVideo) return;
        nativeVideo.preload = 'auto';
        nativeVideo.controls = true;
        nativeVideo.muted = false;
        nativeVideo.addEventListener(
          'playing',
          function () {
            el.classList.add('is-playing');
            if (playBtn) playBtn.remove();
          },
          { once: true }
        );
        var started = nativeVideo.play();
        if (started && started.catch) {
          started.catch(function () {
            /* Sound was refused: try again muted rather than showing nothing. */
            nativeVideo.muted = true;
            nativeVideo.play().catch(function () {
              mounted = false;
              el.classList.remove('is-playing');
              if (playBtn) playBtn.hidden = false;
            });
          });
        }
        return;
      }

      var frame = document.createElement('iframe');
      frame.className = 'oni-media__frame';
      frame.setAttribute('src', embedSrc());
      frame.setAttribute('title', title);
      frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      el.appendChild(frame);
      el.frame = frame;
      el.classList.add('is-playing');
      if (playBtn) playBtn.remove();
    }

    if (playBtn) playBtn.addEventListener('click', play);
  }

  /* Returning from checkout with the back button restores this page from the
     bfcache with the DOM frozen mid-submit, so the add-to-cart button came back
     still spinning. Nothing else resets it, because the original click was
     expected to end in a navigation. */
  function initButtonReset() {
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      $$('.oni-btn.is-loading').forEach(function (b) {
        b.classList.remove('is-loading');
      });
    });
  }

  /* ------------------------------------------------------ misc niceties */

  function initScrollLinks() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-oni-scroll-to]');
      if (!trigger) return;
      event.preventDefault();
      OniLP.scrollTo(trigger.getAttribute('data-oni-scroll-to'));
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.oni-reveal').forEach(function (n) {
        n.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    $$('.oni-reveal').forEach(function (n) {
      io.observe(n);
    });
  }

  /* Only one FAQ row open at a time. */
  function initFaq() {
    $$('[data-oni-faq]').forEach(function (group) {
      $$('details', group).forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          $$('details', group).forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function boot() {
    $$('[data-oni-buybox]').forEach(initBuyBox);
    $$('[data-oni-sticky]').forEach(initSticky);
    $$('[data-oni-video]').forEach(initVideo);
    initButtonReset();
    initScrollLinks();
    initReveal();
    initFaq();
    if (OniLP.variant) renderGlobals(OniLP.variant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
